var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"theme-btn"}},[(_vm.theme === 'default')?_c('img',{attrs:{"src":require("../assets/light.png")},on:{"click":_vm.changeTheme}}):_c('img',{attrs:{"src":require("../assets/dark.png")},on:{"click":_vm.changeTheme}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34eaa464","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThemeBtn.vue
// module id = null
// module chunks = 